const STACK_BREAKPOINT = 1024;
const SECTION_EXTRA_SPACE_PX = 50;

function isStackActive() {
  return window.innerWidth >= STACK_BREAKPOINT;
}

function initStack(container, cards) {
  container.classList.add('is-stacked');

  cards.forEach((card, index) => {
    if (index === 0) {
      gsap.set(card, { y: 0, zIndex: 1 });
    } else {
      gsap.set(card, { y: () => window.innerHeight, zIndex: index + 1 });
    }
  });

  const extraPinDistance = window.innerHeight * 0.5;
  container.style.marginBottom = `${SECTION_EXTRA_SPACE_PX}px`;
  const totalScrollDistance =
    (cards.length - 1) * window.innerHeight + extraPinDistance + SECTION_EXTRA_SPACE_PX;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      start: 'top top',
      end: `+=${totalScrollDistance}`,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      markers: false,
    }
  });

  cards.forEach((card, index) => {
    if (index === 0) return;
    tl.to(card, {
      y: 0,
      ease: 'none',
      duration: 1
    });
  });

  tl.to({}, { duration: 1.0 });
  return tl.scrollTrigger;
}

function uninitStack(container, cards) {
  const st = container._stackScrollTrigger;
  if (st) {
    st.kill();
    container._stackScrollTrigger = null;
  }
  container.classList.remove('is-stacked');
  container.style.marginBottom = '';
  if (cards && cards.length) {
    gsap.set(cards, { clearProps: 'y,zIndex' });
  }
  if (window.ScrollTrigger) {
    ScrollTrigger.refresh();
  }
}

function run() {
  const container = document.querySelector('.event-card-block');
  if (!container) return;

  const cards = gsap.utils.toArray('.event-card-block__item .event-card');

  if (cards.length <= 1) {
    if (container._stackScrollTrigger) uninitStack(container, cards);
    return;
  }

  if (!isStackActive()) {
    uninitStack(container, cards);
    return;
  }

  // Re-init on load/resize: kill existing so we recalculate with new dimensions
  if (container._stackScrollTrigger) {
    uninitStack(container, cards);
  }

  container._stackScrollTrigger = initStack(container, cards);
  if (window.ScrollTrigger) {
    ScrollTrigger.refresh();
  }
}

export function eventCardStack() {
  const onLoad = () => {
    run();
  };

  if (document.readyState === 'complete') {
    onLoad();
  } else {
    window.addEventListener('load', onLoad);
  }

  window.addEventListener('resize', () => {
    run();
  });
}
